/*
 * @Description: 部门详情
 * @Author: 杨志航
 * @Date: 2026-09-06 09:50:22
 */
import React, { useState, useEffect, useRef } from 'react'
import api from 'api'
import {
  Card,
} from 'antd'
import { parseSearch } from '@/utils'
import DepartSection from '../../../module/DepartSection'

const DepartSetting = props => {
  const { location } = props
  const search = parseSearch(location.search)
  const [list, setList] = useState([])
  const departSectionRefs = useRef([])

  useEffect(() => {
    getList()
  }, [])

  //获取列表
  const getList = () => {
    list.forEach((item, index) => {
      if (departSectionRefs.current[index]) {
        departSectionRefs.current[index].setLoadingState(true)
      }
    })

    api.getProfitReportDepartSort({
      groupId: search.id
    }).then(data => {
      setList(data)
      data.forEach((item, index) => {
        if (departSectionRefs.current[index]) {
          departSectionRefs.current[index].setLoadingState(false)
        }
      })
    }).catch(() => {
      list.forEach((item, index) => {
        if (departSectionRefs.current[index]) {
          departSectionRefs.current[index].setLoadingState(false)
        }
      })
    })
  }

  return (
    <>
      {list.map((item, index) => (
        <Card 
          key={index}
          title={item.departType}
          size="small"
          style={{ marginBottom: 20 }}
        >
          <DepartSection 
            ref={node => (departSectionRefs.current[index] = node)}
            dataSource={item.list} 
            getList={getList} 
          />
        </Card>
      ))}
    </>
  )
}
export default DepartSetting